// ----------------------------------------------------------------------
// Staff sign-in code (auth/staff-otp): a one-line note the login page shows
// after the app signed the person out on purpose. It survives the hard
// redirect to /auth/login, so it lives in sessionStorage (this tab only).
// Only a fixed key is stored; never a code, a password or a token.
// ----------------------------------------------------------------------

export type AuthNotice = 'session_ended' | 'password_changed';

const KEY = 'kayfa.authNotice';

export const AUTH_NOTICE_TEXT: Record<AuthNotice, string> = {
  session_ended: 'Your session ended. Sign in again with your password and a new code.',
  password_changed: 'Password changed. Sign in with your new password (we will send you a new code).',
};

export function setAuthNotice(notice: AuthNotice): void {
  try {
    sessionStorage.setItem(KEY, notice);
  } catch {
    /* storage blocked: the login page simply shows no note */
  }
}

export function peekAuthNotice(): AuthNotice | null {
  try {
    const v = sessionStorage.getItem(KEY);
    return v === 'session_ended' || v === 'password_changed' ? v : null;
  } catch {
    return null;
  }
}

export function clearAuthNotice(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
